import { Controller } from '@hotwired/stimulus';
import { FetchRequest } from '@rails/request.js';

export default class extends Controller {
  static values = {
    apiUrl: String,
    favorited: Boolean,
    itemType: String,
    itemId: Number
  };
  static targets = ['icon'];

  toggleFavorite() {
    this.favoritedValue = !this.favoritedValue;
    this.save();
    this.updateDisplay();
  }

  save() {
    new FetchRequest('patch', this.apiUrlValue, { body: JSON.stringify({
      item_type: this.itemTypeValue,
      item_id: this.itemIdValue,
      favorited: this.favoritedValue
    }) }).perform();
  }

  updateDisplay() {
    this.iconTarget.classList.toggle('far');
    this.iconTarget.classList.toggle('fas');
  }
}
